import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { PaymentService } from '../services/payment/payment.service';

import { NgxMatDrpComponent, NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';

@Component({
    selector: 'app-packages-validity',
    templateUrl: './packages-validity.component.html',
    styleUrls: ['./packages-validity.component.css']
})
export class PackagesValidityComponent implements OnInit {
    @ViewChild('accountDetails', { static: true }) accountModal: ModalDirective;
    @ViewChild('packageDetails', { static: true }) packageModal: ModalDirective;
    @ViewChild('dateRangePicker', { static: true }) dateRangePickerView: NgxMatDrpComponent;

    constructor(public foruscareService: ForuscareService, public paymentService: PaymentService) { }

    accounts = ['Prepaid', 'Postpaid'];
    accountType = '';
    today: Date;
    fromDate: string;
    toDate: string;
    selectedAccount = 0;
    selectedAccountName = '';
    selectedPackage = null;
    selectedPackageName = '';
    packageList = [];
    accountPackageList = [];
    totalPackageCount = 0;
    totalAccountPackageCount = 0;
    payload = {
        startDate: '',
        endDate: '',
        subscriptionType: 'PREPAID',
        count: 0,
        offset: 0
    };
    accountPayload = {
        startDate: '',
        endDate: '',
        subscriptionType: "PREPAID",
        count: 10,
        offset: 0,
        accountId: 0
    };
    isAccountModalOpen = false;
    isPackageModalOpen = false;
    dateFormat = '';
    calendarOptions: NgxDrpOptions;
    presets: Array<PresetItem> = [];

    ngOnInit() {
        this.accountType = 'Prepaid';
        this.dateFormat = this.foruscareService.getDateFormat();
        this.today = new Date();
        this.fromDate = new Date(this.today).toJSON().split('T')[0];
        this.toDate = this.fromDate;

        this.setupPresets();
        this.calendarOptions = {
            presets: this.presets,
            format: this.foruscareService.getDateFormat().split(" ")[0],
            range: {
                fromDate: this.today,
                toDate: this.today
            },
            applyLabel: 'Submit',
            calendarOverlayConfig: {
                shouldCloseOnBackdropClick: true,
                hasBackdrop: true
            }
        };
    }

    // Configures the Date Range Selector
    setupPresets() {
        const backDate = (numOfDays: number) => {
            const currentDate = new Date();
            return new Date(currentDate.setDate(currentDate.getDate() - numOfDays));
        };

        const today = new Date();
        const yesterday = backDate(1);
        const minus7 = backDate(7);
        const minus30 = backDate(30);
        const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

        this.presets = [
            { presetLabel: 'Yesterday', range: { fromDate: yesterday, toDate: yesterday } },
            { presetLabel: 'Last 7 Days', range: { fromDate: minus7, toDate: today } },
            { presetLabel: 'Last 30 Days', range: { fromDate: minus30, toDate: today } },
            { presetLabel: 'This Month', range: { fromDate: currMonthStart, toDate: today } },
            { presetLabel: 'Last Month', range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
        ];
    }

    // Updates the selected Date Range filter
    updateDateRange(updatedRange: Range) {
        this.fromDate = new Date(updatedRange.fromDate).toLocaleString('en-GB').split(',')[0].split('/').reverse().join('-');
        this.toDate = new Date(updatedRange.toDate).toLocaleString('en-GB').split(',')[0].split('/').reverse().join('-');
    }

    // Returns the Package Status Text / validity based on the response data recieved
    getPackageStatus(currentStatus: string, onlyStatus: boolean = false) {
        switch (currentStatus) {
            case 'PACKAGE_EXPIRED': {
                return onlyStatus ? false : 'Expired';
            }

            case 'PACKAGE_IN_USE': {
                return onlyStatus ? true : 'In Use';
            }

            case 'PACKAGE_QUOTA_EXCEEDED': {
                return onlyStatus ? false : 'Exceeded';
            }

            case 'PACKAGE_SUBSCRIBED': {
                return onlyStatus ? true : 'Subscribed';
            }

            case 'PACKAGE_SUBSCRIPTION_INITIATED': {
                return onlyStatus ? false : 'Initiated';
            }

            case 'PAYMENT_FAILED': {
                return onlyStatus ? false : 'Payment Failed';
            }
        }
    }

    // fetches packages based on the filters selected
    fetchPackagesByFilter() {
        this.paymentService.getPackagesExpiringByFilter(this.payload).subscribe(response => {
            // Success
            if (response && response.errorCode === 200) {
                if (response.data && response.data.totalCount > 0) {
                    this.totalPackageCount = response.data.totalCount;

                    this.packageList = response.data.response.map(pack => {
                        if (this.payload.subscriptionType === 'PREPAID') {
                            return {
                                ...pack,
                                purchaseDate: pack.purchaseDate.split(' ')[0],
                                expiryDate: pack.expiryDate.split(' ')[0],
                                status: pack.status ? 'Active' : 'Inactive',
                                currentStatus: this.getPackageStatus(pack.currentStatus),
                                isValid: this.getPackageStatus(pack.currentStatus, true)
                            }
                        } else {
                            return {
                                ...pack,
                                expiryDate: pack.expiryDate.split(' ')[0]
                            }
                        }
                    });
                }
            } else {
                // Failed
                this.packageList = [];
                this.totalPackageCount = 0;
            }
        });
    }

    // fetches packages based on the account selected
    fetchPackagesByAccount() {
        this.paymentService.getPackagesExpiringByAccount(this.accountPayload).subscribe(response => {
            // Success
            if (response && response.errorCode === 200) {
                if (response.data && response.data.totalCount > 0) {
                    this.totalAccountPackageCount = response.data.totalCount;

                    this.accountPackageList = response.data.response.map(pack => {
                        if (this.accountPayload.subscriptionType === 'PREPAID') {
                            return {
                                ...pack,
                                purchaseDate: pack.purchaseDate.split(' ')[0],
                                expiryDate: pack.expiryDate.split(' ')[0],
                                status: pack.status ? 'Active' : 'Inactive',
                                currentStatus: this.getPackageStatus(pack.currentStatus),
                                isValid: this.getPackageStatus(pack.currentStatus, true)
                            }
                        } else {
                            return {
                                ...pack,
                                expiryDate: pack.expiryDate.split(' ')[0]
                            }
                        }
                    });
                }
            } else {
                // Failed
                this.accountPackageList = [];
                this.totalAccountPackageCount = 0;
            }
        });
    }

    // Search for packages with selected filters
    searchPackagesByFilter() {
        this.payload = {
            startDate: this.fromDate,
            endDate: this.toDate,
            subscriptionType: this.accountType.toUpperCase(),
            count: 10,
            offset: 0
        };

        this.fetchPackagesByFilter();
    }

    // Fetches next set of pagination for packages by filter
    loadNextPagination(event: any) {
        this.payload = {
            startDate: this.fromDate,
            endDate: this.toDate,
            subscriptionType: this.accountType.toUpperCase(),
            count: 10,
            offset: event.first
        };

        this.fetchPackagesByFilter();
    }

    // Fetches next set of pagination for packages by account
    loadNextAccountPagination(event: any) {
        this.accountPayload = {
            accountId: this.selectedAccount,
            startDate: this.fromDate,
            endDate: this.toDate,
            subscriptionType: this.accountType.toUpperCase(),
            count: 10,
            offset: event.first
        };

        this.fetchPackagesByAccount();
    }

    // Fetch packages for selected Account. Also opens the Modal
    getPackagesByAccount(accountId: number, accountName: string) {
        this.selectedAccount = accountId;
        this.selectedAccountName = accountName;

        this.accountModal.show();
        this.isAccountModalOpen = true;
    }

    // Closes the Modal where packages are shown for an account
    closeAccountModal() {
        this.accountModal.hide();
        this.isAccountModalOpen = false;
    }

    // Opens Modal to Show Package Details
    showPackageDetails(pack: any) {
        this.selectedPackage = { ...pack };
        this.selectedPackageName = this.selectedPackage.packageName;

        this.packageModal.show();
        this.isPackageModalOpen = true;
    }

    // Closes the Package Modal
    closePackageModal() {
        this.packageModal.hide();
        this.isPackageModalOpen = false;
    }
}